import { startGame } from './game.js';

const isLocalhost = ['localhost', '127.0.0.1', '[::1]', ''].includes(location.hostname);

if (location.search.includes('meshtest')) {
  void import('./meshtest.js').then((m) => m.startMeshTest());
} else if (location.search.includes('editor') && isLocalhost) {
  // Dev-only free-walk editor: no server/match/bots, F3 HUD on. Localhost only.
  void import('./editor.js').then((m) => m.startEditor());
} else {
  startGame();
}
